import { render } from "./DndLeads.vue?vue&type=template&id=27227866&scoped=true"
import script from "./DndLeads.vue?vue&type=script&lang=js"
export * from "./DndLeads.vue?vue&type=script&lang=js"

import "./DndLeads.vue?vue&type=style&index=0&id=27227866&scoped=true&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27227866"]])

export default __exports__